// src/screens/AccessDeniedScreen.js
import React from "react";

const AccessDeniedScreen = () => {
  return (
    <div className="screen-container">
      <div className="thank-you-container">
        <div
          className="thank-you-icon"
          style={{ background: "#ffebee", color: "#f44336" }}
        >
          !
        </div>
        <h1 className="thank-you-title">Access Denied</h1>
        <p className="thank-you-message">
          This link has expired or is invalid. Please scan a valid QR code at the
          event to continue.
        </p>
      </div>
    </div>
  );
};

export default AccessDeniedScreen;
